import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum TagwallReceivingTicketKeys {
  itemNumber = 'itemNumber', // line item number, not to be entered by user
  itemName = 'itemName', // name of the item, often SKU, Unique ID, refernce ID, etc
  notes = 'notes', // notes about the item (human parseable)
  itemQty = 'itemQty', // quantity of the item for order
}

export const tagwallReceivingTicketFileDataSchema = yup.object().shape({
  organizationLogoOverride: yup.string().nullable().optional(),
  contact: yup
    .object()
    .shape({
      name: yup.string().nullable().optional(),
      phoneNumber: yup.string().nullable().optional(),
    })
    .required(),
  vendor: yup
    .object()
    .shape({
      clientNumber: yup.string().nullable().optional(),
      companyName: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      addressLine2: yup.string().nullable().optional(),
      cityStateZip: yup.string().nullable().optional(),
    })
    .required(),
  receivingTicketNumber: yup.string().nullable().optional(),
  proposalNumber: yup.string().nullable().optional(),
  linkedPoNumber: yup.string().nullable().optional(),
  estimatedDeliveryTime: yup.string().nullable().optional(),
  deliveryInstructions: yup.string().nullable().optional(),
  date: yup.string().nullable().optional(),
  shipTo: yup
    .object()
    .shape({
      company: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      addressLine2: yup.string().nullable().optional(),
      cityStateZip: yup.string().nullable().optional(),
    })
    .required(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemNumber: yup.number().nullable().optional(),
        itemName: yup.string().nullable().optional(),
        notes: yup.string().nullable().optional(),
        itemQty: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type TagwallReceivingTicketFileData = yup.InferType<
  typeof tagwallReceivingTicketFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<TagwallReceivingTicketFileData>

export const tagwallReceivingTicketFileMappings: RequiredFileData = {
  organizationLogoOverride: '92696ac7-ce71-42e5-88d0-d209cc4a05ec',
  contact: {
    name: 'b175fd31-d74f-40a1-a85b-c2b3360613e7',
    phoneNumber: '291df470-2c22-4528-9ebf-44c1498cc2f2',
  },
  vendor: {
    clientNumber: '8c989809-4776-43f9-a372-2e6d8b01529d',
    companyName: '4126b88a-0d05-4504-82d5-d0ec7ebdf673',
    addressLine1: '15c129f4-7afb-443a-aae6-3dab5cfa9962',
    addressLine2: '59747a02-a131-42ee-81bb-729443380c21',
    cityStateZip: 'c3d04170-6152-4c1e-9d5f-109567786f67',
  },
  receivingTicketNumber: '992c3662-ae7b-49aa-92cf-76b62d22e21c',
  proposalNumber: '2df2a019-f75f-4917-9401-0a098b58077e',
  linkedPoNumber: '563e5a4e-26c0-470e-b4cd-7374124e94fe',
  estimatedDeliveryTime: 'e78edae9-03bd-4aae-8b9b-1a17ce6696a6',
  deliveryInstructions: '16911634-2bee-4973-a563-e5ff2122eef6',
  date: '3b03a7ae-8124-4628-a407-7950879d806b',
  shipTo: {
    company: '15980b32-07d0-47e6-9d86-4a571ccb0b7f',
    addressLine1: '243e70c8-7629-4a84-bbde-0ecc9ab41473',
    addressLine2: 'bb705e79-1c85-4dbb-bec5-e5be47a913fe',
    cityStateZip: '337c213b-831a-427e-ad1b-1af94ed8b176',
  },
  items: [
    {
      itemNumber: null,
      itemName: 'ffb87851-c098-4e7d-b698-e0cb3c7a78b4',
      notes: '2f5b93fc-fa33-4fba-aa58-1f803469a024',
      itemQty: '97cb8d82-744c-47af-a702-cd5743e448de',
    },
  ],
}
